import { createUseStyles } from 'react-jss';
import { backgrounds, colors } from '../../utils/theme';

export default createUseStyles({
  floatButton: {
    zIndex: 20,
    width: '80px',
    minHeight: '80px',
    insetBlockEnd: '24px',
    '& .ant-float-btn-primary': {
      width: '80px',
      height: '80px',
      boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
      backgroundColor: colors.secondary,

      '& .ant-float-btn-body': {
        backgroundColor: colors.secondary,
      },
      '& .ant-float-btn-icon': {
        width: '24px !important',
        height: '24px',
        '& >svg': {
          width: '24px',
          height: '24px',
          '& path': {
            fill: backgrounds.bg4,
          },
        },
      },
    },
    '& .ant-float-btn-group-wrap': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      marginBottom: '0px',
      '& .ant-float-btn': {
        marginBottom: '24px',
        width: '60px',
        height: '60px',
        '& .ant-float-btn-body': {
          width: '60px',
          height: '60px',
          backgroundColor: colors.primary90,
          '& .ant-float-btn-icon': {
            display: 'flex',
            width: 'unset',
          },
        },
      },
    },
  },
});
